import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt, faCopy, faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';

// Modules
import { isSignedIn } from '../../../../../modules/user';
import Window from '../../../../../modules/window';

// Base
import Button from '../../../base/button';

// Related Components
import Share from './share_buttons/share';

export default class ShareButtons extends React.Component {
  static propTypes = {
    opportunity: PropTypes.object.isRequired,
  };

  render() {
    const { opportunity } = this.props;
    return (
      <React.Fragment>
        <h5 className='med-bold'>
          <FontAwesomeIcon
            icon={faShareAlt}
            className='margin-right-7'
            fixedWidth
          />
          Share Job Post
        </h5>
        <div className='margin-left-30 flex flex-row'>
          <div>
            <a href={opportunity.shareFacebookUrl()} className='facebook-link' target='_blank' />
          </div>
          <div>
            <a href={opportunity.shareTwitterUrl()} className='twitter-link' target='_blank' />
          </div>
          <div>
            <a href={opportunity.shareLinkedinUrl()} className='linkedin-link' target='_blank' />
          </div>
          {
            isSignedIn() &&
            <div><Share {...{ opportunity }} /></div>
          }
          {
            !isSignedIn() &&
            <div>
              <a href={`mailto:?subject=I thought you’d be a good fit for this role&body=Interested? View Opportunity: ${opportunity.shareUrl()}`} className="mail-link" target="_blank" />
            </div>
          }
          <div>
            <CopyToClipboard
              text={`${opportunity.shareUrl()}`}
              onCopy={() => Window.flash.success('Link Copied to Clipboard')}
            >
              <Button
                className='btn height-30 width-30 flex justify-center vertical-align'
                size='custom'
                color='primary'
                rounded
              >
                <FontAwesomeIcon
                  className='light'
                  icon={faCopy}
                  title='Copy job post link'
                />
              </Button>
            </CopyToClipboard>
          </div>
        </div>

      </React.Fragment>
    )
  }
}